import { render, staticRenderFns } from "./addOrgDialog.vue?vue&type=template&id=6c0fb736"
import script from "./addOrgDialog.vue?vue&type=script&lang=js"
export * from "./addOrgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports